import clsx from 'clsx';
import { PromotionContext } from '../../PromotionListWithFilters/context';
import React, { useContext } from 'react';
import './style.scss';

const Tag = (props) => {
  const { allFilters } = useContext(PromotionContext);
  const displayName = props?.item?.name || props?.item?.fields?.title?.value;
  return (
    !!displayName &&
    displayName !== '' && (
      <div
        className={clsx(
          'global-tags-tag flex-inline',
          allFilters?.tagFilter?.some((item) => item?.title === displayName) ? 'selected-tag' : ''
        )}
      >
        {displayName}
      </div>
    )
  );
};

export default Tag;
